"use client";

import { Shortcut } from "../hooks/keyboard-shortcuts-manager-v2";

export function KeyboardShortcut({
	shortcut,
	layerName,
}: { shortcut: Shortcut; layerName: string }): null {
	// useKeyboardShortcuts(shortcuts, layerName);

	return null;
}
